import { render } from "./show.vue?vue&type=template&id=675c9e54&scoped=true&ts=true"
import script from "./show.vue?vue&type=script&lang=ts"
export * from "./show.vue?vue&type=script&lang=ts"

import "./show.vue?vue&type=style&index=0&id=675c9e54&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675c9e54"]])

export default __exports__